export const mapToArray = <K, V>(map: Map<K, V>) => Array.from(map.values())
